import { actions as actionsAuth } from "app/containers/Auth/redux/slice";
import {
  validatePasswordField,
  validateProfileForm,
} from "app/containers/OnBoarding/helpers";
import { selectProfileForm } from "app/containers/OnBoarding/redux/selector";
import { actions } from "app/containers/OnBoarding/redux/slice";
import { userOnboardingStage } from "app/types";
import { useQueryState } from "nuqs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function useCreateProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isGoogleLogin] = useQueryState("isGoogleLogin");
  const [userName] = useQueryState("userName");
  const [hash] = useQueryState("hash");
  const { name, password, confirmPassword, timezone, isLoading } =
    useSelector(selectProfileForm);

  useEffect(() => {
    if (userName) {
      dispatch(actions.setProfileFormValue({ name: "name", value: userName }));
    }
  }, [userName]);

  useEffect(() => {
    if (hash) {
      dispatch(actionsAuth.verifyEmailRequest({ code: hash as string }));
    }
  }, [hash]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(actions.setProfileFormValue({ name, value }));
    if (name === "password") {
      const errors = validatePasswordField({
        name: "password",
        value: value,
      });
      if (errors.length > 0) {
        dispatch(actions.setProfileFormErrors(errors));
      }
    }
  };
  const handleSelect = (name: string, value: string) => {
    dispatch(actions.setProfileFormValue({ name, value }));
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const inviteToken = localStorage.getItem("inviteToken");
    const data = {
      name,
      password: isGoogleLogin ? { value: "", error: "" } : password,
      confirmPassword: isGoogleLogin
        ? { value: "", error: "" }
        : confirmPassword,
      timezone,
    };

    const errors = validateProfileForm(data, !!isGoogleLogin);
    if (errors.length > 0) {
      dispatch(actions.setProfileFormErrors(errors));
      return;
    }

    dispatch(
      actions.saveProfileRequest({
        inviteToken: inviteToken as string,
        callback: (onBoardingState: userOnboardingStage) => {
          dispatch(actions.clearProfileForm());
          if (onBoardingState === userOnboardingStage.COMPLETED) {
            navigate("/onboarding/welcome?callback=/app/home");
          } else {
            navigate("/onboarding/welcome");
          }
        },
      })
    );
  };

  const isDisabled = () => {
    if (!isGoogleLogin) {
      return (
        !name.value ||
        !password.value ||
        !confirmPassword.value ||
        !timezone.value
      );
    }
    return !name.value || !timezone.value;
  };

  return {
    handleSubmit,
    handleChange,
    isDisabled,
    isLoading,
    isGoogleLogin,
    name,
    password,
    confirmPassword,
    timezone,
    handleSelect,
  };
}
